import { cn } from "./../lib/utils";



export default function OALogo({className, variant = "red"}) {
    return (
    <>
        <div className='w-full flex justify-center items-center'>
            <img className={cn('w-[118px] h-[56px] xl:w-[218px] xl:h-[70px] object-fill', className)} alt="Logo On Air Club" src={variant==="red"?"/oa-logo.svg":"/oa-white-logo.png"} />
        </div> 
    </>
    )
}
